import React, { useEffect, useState, version } from 'react'
import styles from './Admin.module.css';
import Logo from '../../assets/updatelogo.svg'
import searchIcon from '../../assets/search-icon.png'
import rpDashboardIcon from '../../assets/rp-dashboard-icon.png'
import rpReportIcon from '../../assets/rp-report-icon.png'
import dashboardIcon from '../../assets/dashboard-icon.png'
import reportIcon from '../../assets/report-icon.png'
import settings from '../../assets/settings.png'
import blackLogout from '../../assets/black-logout.png'
import download from '../../assets/download-icon.png'
import filter from '../../assets/filter.png'
import refresh from '../../assets/refresh.png'
import upIcon from '../../assets/up-icon.png'
import rmIcon from '../../assets/rm-icon.png'
import planIcon from '../../assets/plan-icon.png'
import yearIcon from "../../assets/event_icon.svg"
import monthIcon from "../../assets/month_icon.svg"
import dayIcon from "../../assets/loader_icon.svg"
// import { prpNonEncHttpAPI } from '../../services/prpNonEncHttpAPI';
import { prpHttpAPI } from '../../services/prpHttpAPI';
import { useNavigate } from 'react-router-dom';
import LineChart from '../../components/Chart/LineChart';
import channelData from '../../master/channel.json'
import regionData from '../../master/region.json'
import branchData from '../../master/branch.json'
import zoneData from '../../master/zone.json'
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType, AlignmentType, HeadingLevel } from 'docx';
import * as XLSX from 'xlsx';

const Admin = () => {
  const navigate = useNavigate();
  const data = channelData.recordset;
  const uniqueChannels = new Set();
  const channelsData = [];
  const [planCount, setPlanCount] = useState(null);

  for (const item of data) {
    if (item.CHANNEL && !uniqueChannels.has(item.CHANNEL)) {
      uniqueChannels.add(item.CHANNEL);
      channelsData.push(item);
    }
  }
  const regions = regionData.recordset
  const branches = branchData.recordset
  const zones = zoneData.recordset
  const [initialAdminData, setInitialAdminData] = useState([]);
  const [filteredData, setFilteredData] = useState([])
  const [loading, setLoading] = useState([false]);
  const [totalPlans, setTotalPlans] = useState([])
  const [totalRM, setTotalRM] = useState(0);
  const [topCreators, setTopCreators] = useState([]);

  const checkUserLogin = async () => {
    const localtoken = localStorage.getItem("ssotoken");
    if (!localtoken) {
      window.location.href = `${window.location.origin}/login`;
    }
  }

  useEffect(() => {
    checkUserLogin();

  }, [])

  const getLast15DaysStart = () => {
    const today = new Date();
    const last15DaysStart = new Date();
    last15DaysStart.setDate(today.getDate() - 14); // Start of the last 15 days
    return last15DaysStart.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const getNextDate = (date) => {
    const today = new Date(date);

    today.setDate(today.getDate() + 1); // Add 1 day to the current date
    console.log("next date", today);
    return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };
  const getCurrentDate = () => {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0'); // Ensures two-digit day
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Ensures two-digit month (Months are 0-based)
    const year = currentDate.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    console.log(formattedDate);
    return formattedDate;
  }
  const sortByCreatedAtAsc = (data) => {
    return data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  };
  const [fromDate, setFromDate] = useState(getLast15DaysStart())
  const [toDate, setToDate] = useState(getNextDate(new Date()));

  const userData = {
    fromdate: fromDate,
    todate: getNextDate(toDate)
  };
  // const userData={
  //   fromdate:"2025-03-01",
  //   todate: "2025-03-20"
  // }
  const getData = async () => {
    console.log("user", userData);
    const localtoken = localStorage.getItem("ssotoken");
    let result;

    if (localStorage.getItem('isAdmin') == 1) {
      console.log("admin called");
      setLoading(true);
      result = await prpHttpAPI(userData, 'admin', localtoken, "POST");
      if (!result.success) {
        console.log("non-admin called");
        result = await prpHttpAPI(userData, 'user-dashboard', localtoken, "POST");
        setLoading(false);
      }
      else {
        setLoading(false);
      }

    } else {
      console.log("non-admin called");
      setLoading(true);
      result = await prpHttpAPI(userData, 'user-dashboard', localtoken, "POST");
      setLoading(false);
    }

    if (result.success) {
      console.log("admin data is:-----------", result);
      const sortedData = result?.data?.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      setInitialAdminData(sortedData);
      setFilteredData(sortedData);  // Set both original and filtered data
    } else {
      console.log("result in error", result);
      setInitialAdminData([]);
      setFilteredData([]);
    }
  };

  const getTotalPlans = async () => {
    const localtoken = localStorage.getItem("ssotoken");
    let result;
    const data = {
      fromdate: "2025-02-10",
      todate: getNextDate(toDate),
    };
    // if (localStorage.getItem('isAdmin') == 0) {
    setLoading(true);
    result = await prpHttpAPI(data, 'user-dashboard', localtoken, "POST");
    setLoading(false);
    // }else{
    //   result = null;
    // }

    if (result?.success) {
      console.log("total plan count:", result);
      // const ascPlans = sortByCreatedAtAsc(result.data)
      setTotalPlans(result?.data);  // ✅ Set the totalPlans properly
    } else {
      console.log("error or admin-totalplans", result);
    }
  };

  const getTotalRMs = async () => {
    const localtoken = localStorage.getItem("ssotoken");
    const data = {
      fromdate: "2025-02-10",
      todate: getNextDate(toDate),
      flagType: "count"
    };

    let result;
    // if (localStorage.getItem('isAdmin') == 0) {
    setLoading(true);
    result = await prpHttpAPI(data, 'user-dashboard', localtoken, "POST");
    setLoading(false);
    // } else {
    // result = null;
    // }

    if (result?.success) {
      console.log("total rm:", result);
      setTotalRM(result.data[0].total_count);
    } else {
      console.log("Error or admin-call", result);
    }
  };

  // ✅ Proper async handling with awaiting totalPlans
  const topPlanCreators = async () => {
    // await getTotalPlans(); // Ensure the totalPlans are fetched first
    console.log("total plans are::", totalPlans);

    // 1️⃣ Group data by rm_code
    const rmStats = totalPlans.reduce((acc, item) => {
      const { rm_code, EMP_NAME, rmcode, rmname, created_at } = item;
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[new Date(created_at).getMonth()];


      if (!acc[rm_code || rmcode]) {
        acc[rm_code || rmcode] = {
          name: EMP_NAME || rmname,
          total_plans: 0,
          plans_by_month: {}
        };
      }

      acc[rm_code || rmcode].total_plans++;

      if (!acc[rm_code || rmcode].plans_by_month[month]) {
        acc[rm_code || rmcode].plans_by_month[month] = 0;
      }

      acc[rm_code || rmcode].plans_by_month[month]++;

      return acc;
    }, {});
    console.log("rmstats", rmStats);

    // 2️⃣ Convert the object into an array and sort by total_plans in descending order
    const result = Object.entries(rmStats)
      .map(([rm_code, details]) => ({
        rm_code,
        name: details.name,
        total_plans: details.total_plans,
        plans_by_month: details.plans_by_month
      }))
      .sort((a, b) => b.total_plans - a.total_plans);

    console.log("Final Sorted Data:", result);

    const topThree = result.slice(0, 3);
    console.log("Top 3 Creators:", topThree);
    return topThree;
  };
  /////////////
  useEffect(() => {
    getTotalRMs();
    getTotalPlans();

  }, [])
  useEffect(() => {
    // Use async IIFE to await async functions
    (async () => {
      const data = await topPlanCreators();
      console.log("Top Creators:", data);
      setTopCreators(data);  // ✅ Set top creators properly
    })();
  }, [totalPlans])
  useEffect(() => {
    // getData();
  }, [fromDate, toDate])

  // search for versions 
  const handleVersionSearch = async (plan_id) => {

    try {
      let data = { plan_id: plan_id };
      console.log("data", data);

      const localtoken = localStorage.getItem("ssotoken");

      const result = await prpHttpAPI(data, "search-plan", localtoken, "POST");

      if (result.success) {
        console.log("result in search", result);
        console.log("plan id is ", result.data.lastCompletedPlan.planDetails.plan_id);
        //   let versions = null;
        //   let str = result.data.lastCompletedPlan.planDetails.plan_id;
        //   if (str.includes('_')) {
        //     // Split the string by underscore and convert the part after it to a number
        //     const parts = str.split('_');
        //     versions = parseInt(parts[1], 10);
        // } else {
        //     // If no underscore, return 1
        //     versions = 1;
        // }
        // console.log('version is', versions);
        //   console.log('----------------', plan_id, versions)
        const versions = result.data.version.versions;
        const planDetails = result.data.lastCompletedPlan?.planDetails || {};
        const clientDetails = result.data.lastCompletedPlan?.clientsDetails || {};
        handleEyeClick(plan_id, versions, clientDetails, planDetails);
      } else {
        console.log("result error in view click");
        return;
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const handleEyeClick = (plan_id, versions, clientDetails = {}, planDetails = {}) => {
    let planID = "";
    let editableID = '';
    if (versions > 1) {
      planID = `${plan_id}_${versions}`
      editableID = `${plan_id}_${versions}`;
    } else if (versions == 1) {
      planID = plan_id;
      editableID = `${plan_id}_${versions}`;
    } else {
      return;
    }

    // Clear stale session data from any previous plan
    localStorage.removeItem("planDetails");
    localStorage.removeItem("clientInvestmentData");
    localStorage.removeItem("cashflow");
    localStorage.removeItem("retirementCashflow");

    // Set userData so PlanOutput.jsx reads the correct plan_id
    const userData = { ...clientDetails, plan_id: planID };
    localStorage.setItem("userData", JSON.stringify(userData));
    localStorage.setItem("versions", versions);
    localStorage.setItem("editableID", editableID);
    localStorage.setItem("planCompletedFlag", JSON.stringify(true));
    localStorage.setItem("editableData", JSON.stringify({}));

    const newRoute = "/plan-output";
    const fullPath = window.location.origin + newRoute;
    window.open(fullPath, '_blank');   // Open in new tab
  }

  const [filters, setFilters] = useState({
    channel: "",
    region: "",
    zone: "",
    branch: "",
  });
  const [activeItem, setActiveItem] = useState('report');

  const formatDate = (isoString) => {
    const [year, month, day] = isoString?.split("T")[0].split("-"); // Extracts date and splits it
    return `${day}-${month}-${year}`; // Rearranges to DD-MM-YYYY
  };
  const getRetirementYear = (currentYear, currentAge, retirementAge) => {
    const yearsLeft = retirementAge - currentAge; // Calculate remaining years
    return currentYear + yearsLeft; // Add remaining years to the current year
  };
  const capitalizeName = (name) => {
    if (name) {
      return name
        .trim() // remove extra spaces from start and end
        .split(' ') // split into words
        .filter(Boolean) // remove any empty strings caused by multiple spaces
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // capitalize first letter
        .join(' '); // join words back
    }
    else {
      return "";
    }

  }

  // ✅ Apply in-memory filtering
  const applyFilters = () => {
    const filtered = initialAdminData.filter((item) => {
      const matchesChannel = !filters.channel || item.CHANNEL === filters.channel;
      const matchesRegion = !filters.region || item.REGION_NAME === filters.region;
      const matchesZone = !filters.zone || item.ZONE_NAME === filters.zone;
      const matchesBranch = !filters.branch || item.BRANCH_NAME === filters.branch;

      return matchesChannel && matchesRegion && matchesZone && matchesBranch;
    });

    console.log("Filtered data:", filtered);
    setFilteredData(filtered);  // Update the displayed data
  };

  // ✅ Handle filter change and apply filtering
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // ✅ Trigger filtering whenever filters change
  useEffect(() => {
    applyFilters();
  }, [filters, initialAdminData]);

  // const filteredData = initialAdminData?.filter((item) => {
  //   const itemDate = new Date(item.created_at);
  //   const fromDate = filters.fromDate ? new Date(filters.fromDate) : null;
  //   const toDate = filters.toDate ? new Date(filters.toDate) : null;

  //   return (
  //     (!filters.fromDate || itemDate >= fromDate) &&
  //     (!filters.toDate || itemDate <= toDate) &&
  //     (!filters.channel || item.channel === filters.channel) &&
  //     (!filters.region || item.region === filters.region) &&
  //     (!filters.zone || item.zone === filters.zone) &&
  //     (!filters.branch || item.branch === filters.branch)
  //   );
  // });

  const downloadUserCSV = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME, item.BRANCH_NAME,

      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '', capitalizeName(item.client_name), item.plan_id, getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement), formatDate(item.created_at), formatDate(item.updated_at),

      capitalizeName(item.EMP_NAME),
      item.rm_code]);


      let csvContent = "data:text/csv;charset=utf-8,"
        + [headers, ...rows].map(e => e.join(",")).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `prp-report-${getCurrentDate()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.log("Admin data is of length 0.");
    }


  };
  const downloadAdminCSV = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "PLAN STATUS", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME,
      item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '',
      capitalizeName(item.client_name), item.plan_id, item.plan_completed == 1 ? "Plan Created" : "Pending",
      getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement),
      formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.rmname),
      item.rmcode ? item.rmcode : '']);

      let csvContent = "data:text/csv;charset=utf-8,"
        + [headers, ...rows].map(e => e.join(",")).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `prp-report-${getCurrentDate()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.log("Admin data is of length 0.");
    }

  };
  const downloadUserPDF = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME, item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '', capitalizeName(item.client_name), item.plan_id, getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement), formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.EMP_NAME),
      item.rm_code]);

      const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
      doc.setFontSize(14);
      doc.text('PRP Report', 40, 30);

      autoTable(doc, {
        head: [headers],
        body: rows,
        startY: 45,
        styles: { fontSize: 7, cellPadding: 3 },
        headStyles: { fillColor: [178, 34, 34] },
        margin: { left: 20, right: 20 },
      });

      doc.save(`prp-report-${getCurrentDate()}.pdf`);
    } else {
      console.log("Admin data is of length 0.");
    }
  };

  const downloadAdminPDF = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "PLAN STATUS", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME,
      item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '',
      capitalizeName(item.client_name), item.plan_id, item.plan_completed == 1 ? "Plan Created" : "Pending",
      getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement),
      formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.rmname),
      item.rmcode ? item.rmcode : '']);

      const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
      doc.setFontSize(14);
      doc.text('PRP Report', 40, 30);

      autoTable(doc, {
        head: [headers],
        body: rows,
        startY: 45,
        styles: { fontSize: 7, cellPadding: 3 },
        headStyles: { fillColor: [178, 34, 34] },
        margin: { left: 20, right: 20 },
      });

      doc.save(`prp-report-${getCurrentDate()}.pdf`);
    } else {
      console.log("Admin data is of length 0.");
    }
  };

  const buildWordTable = (headers, rows) => {
    const headerRow = new TableRow({
      tableHeader: true,
      children: headers.map(h => new TableCell({
        shading: { fill: "B22222" },
        children: [new Paragraph({
          alignment: AlignmentType.CENTER,
          children: [new TextRun({ text: String(h), bold: true, color: "FFFFFF", size: 16 })],
        })],
      })),
    });

    const bodyRows = rows.map(row => new TableRow({
      children: row.map(cell => new TableCell({
        children: [new Paragraph({
          children: [new TextRun({ text: String(cell ?? ''), size: 16 })],
        })],
      })),
    }));

    return new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [headerRow, ...bodyRows],
    });
  };
  const downloadAdminWord = async () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "PLAN STATUS", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME,
      item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '',
      capitalizeName(item.client_name), item.plan_id, item.plan_completed == 1 ? "Plan Created" : "Pending",
      getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement),
      formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.rmname),
      item.rmcode ? item.rmcode : '']);

      const table = buildWordTable(headers, rows);
      const doc = new Document({
        sections: [{
          properties: { page: { size: { orientation: "landscape" } } },
          children: [
            new Paragraph({
              heading: HeadingLevel.HEADING_1,
              children: [new TextRun({ text: "PRP Report", bold: true })],
            }),
            new Paragraph({ text: "" }),
            table,
          ],
        }],
      });

      const blob = await Packer.toBlob(doc);
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `prp-report-${getCurrentDate()}.docx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } else {
      console.log("Admin data is of length 0.");
    }
  };
  const downloadUserWord = async () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME, item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '', capitalizeName(item.client_name), item.plan_id, getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement), formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.EMP_NAME),
      item.rm_code]);

      const table = buildWordTable(headers, rows);
      const doc = new Document({
        sections: [{
          properties: { page: { size: { orientation: "landscape" } } },
          children: [
            new Paragraph({
              heading: HeadingLevel.HEADING_1,
              children: [new TextRun({ text: "PRP Report", bold: true })],
            }),
            new Paragraph({ text: "" }),
            table,
          ],
        }],
      });

      const blob = await Packer.toBlob(doc);
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `prp-report-${getCurrentDate()}.docx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } else {
      console.log("Admin data is of length 0.");
    }
  };
  const downloadAdminExcel = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "PLAN STATUS", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME,
      item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '',
      capitalizeName(item.client_name), item.plan_id, item.plan_completed == 1 ? "Plan Created" : "Pending",
      getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement),
      formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.rmname),
      item.rmcode ? item.rmcode : '']);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      worksheet['!cols'] = headers.map(() => ({ wch: 18 }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "PRP Report");
      XLSX.writeFile(workbook, `prp-report-${getCurrentDate()}.xlsx`);
    } else {
      console.log("Admin data is of length 0.");
    }
  };
  const downloadUserExcel = () => {
    if (filteredData.length > 0) {
      const headers = ["CHANNEL", "REGION", "ZONE", "BRANCH",
        "RM NAME", "BUSINESS CODE", "INVESTOR", "RP PLAN ID", "YEAR OF RETIREMENT",
        "PLAN CREATION DATE", "PLAN REVISION DATE", "PLAN CREATED BY", "SPOC RM CODE"];

      const rows = filteredData.map(item => [item.CHANNEL, item.REGION_NAME, item.ZONE_NAME, item.BRANCH_NAME,
      item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : '',
      item.spoc_rm ? item.spoc_rm : '', capitalizeName(item.client_name), item.plan_id, getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement), formatDate(item.created_at), formatDate(item.updated_at),
      capitalizeName(item.EMP_NAME),
      item.rm_code]);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      worksheet['!cols'] = headers.map(() => ({ wch: 18 }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "PRP Report");
      XLSX.writeFile(workbook, `prp-report-${getCurrentDate()}.xlsx`);
    } else {
      console.log("Admin data is of length 0.");
    }
  };

  const handleLogout = () => {
    // Clear session storage (or localStorage if you want)
    localStorage.clear();
    // If you're using localStorage, you can do the same
    // localStorage.clear();

    // Optionally, remove specific keys instead of clearing everything
    //localStorage.removeItem('yourKey');
    // localStorage.removeItem('yourKey');

    // Redirect to the login page
    window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;
    navigate('/?action=logout'); // Adjust the path to your login page
  };

  const handleSearchSubmit = () => {
    // Simply triggers your existing data fetch function manually
    getData();
  };

  const getRMDetails = async () => {
    const localtoken = localStorage.getItem("ssotoken");
    const result = await prpHttpAPI(null, 'rm-details', localtoken, "POST");
    if (result?.success) {
      setPlanCount(result.data)
      console.log("result is", result.data);
    }
    const data = {
      flagType: "default"
    }

    const rmInfo = await prpHttpAPI(data, 'rm-info', localtoken, "POST");
    if (rmInfo?.success) {
      // setPlanCount(result.data)
      localStorage.setItem("logged_rm_info", JSON.stringify(rmInfo.data[0]));
      // const isAdmin = rmInfo?.data[0].is_admin_or_not;
      localStorage.setItem('isAdmin', rmInfo.isAdmin);
      console.log("RM info is", JSON.stringify(rmInfo.data[0]));
    }


  }

  useEffect(() => {
    checkUserLogin();
    getRMDetails();
  }, [])
  return (
    <div className={styles.main}>
      <div className={styles.bottomContent}>
        <div className={styles.leftHead}>
                    <div className={styles.sideBrand}>
            <BarsIcon /><span>Admin Panel</span>
          </div>
          <div className={styles.navList}>
            <ul>
              <li onClick={() => setActiveItem('dashboard')} className={activeItem == 'dashboard' ? styles.active : ""}>
                <HomeIcon /><span>Dashboard</span>
              </li>
              <li onClick={() => setActiveItem('report')} className={activeItem == 'report' ? styles.active : ""}>
                <FileIcon /><span>Report</span>
              </li>
            </ul>
          </div>
          <div className={styles.footList}>
            {/* <div><span><img src={settings} alt="settings" /></span><span>Settings</span></div> */}
            {/* <div onClick={handleLogout} ><span><img src={blackLogout} alt="logout" /></span><span>Logout</span></div>/ */}
          </div>
        </div>
        {activeItem == 'dashboard' ?
          <div className={styles.rightContent}>
            <div className={styles.pageHeader}>
              <span className={styles.pageIcon}><HomeIcon /></span>
              <div>
                <h2>Dashboard</h2>
                <p>Overview of plans created and top plan creators.</p>
              </div>
            </div>
            <div className={styles.cardDiv}>

              <div className={styles.card}>
                <div className={styles.cardTop}>
                  <span className={styles.topContent}>
                    <span>Total RMs</span>
                    <span>  {loading ?
                      <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
                        <span className="sr-only"></span>
                      </div> : totalRM}</span>
                  </span>
                  <span className={styles.topImg}><img src={rmIcon} alt="rm-icon" /></span>
                </div>
              </div>

              <div className={styles.card}>
                <div className={styles.cardTop}>
                  <span className={styles.topContent}>
                    <span>Plan Created</span>
                    <span> {loading ?
                      <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
                        <span className="sr-only"></span>
                      </div> : totalPlans.length}</span>
                  </span>
                  <span className={styles.topImg}><img src={planIcon} alt="plan-icon" /></span>
                </div>
              </div>

              <div className={styles.card}>
                <div className={styles.cardTop}>
                  <span className={styles.topContent}>
                    <span>Year To Date</span>

                    {planCount?.yearlyCount != null ? <span>{planCount.yearlyCount}</span> :
                      <div className={` spinner-border  ${styles.loaderDiv} `} style={{ color: '#6fa287' }} role="status">
                        <span className="sr-only"></span>
                      </div>}
                  </span>
                  <span className={styles.iconBox}><img src={yearIcon} alt="Year-icon" /></span>
                </div>
              </div>

              <div className={styles.card}>
                <div className={styles.cardTop}>
                  <span className={styles.topContent}>
                    <span>Month To Date</span>

                    {planCount?.monthlyCount != null ? <span>{planCount.monthlyCount}</span> : <div className={` spinner-border ${styles.loaderDiv}`} style={{ color: '#6fa287' }} role="status">
                      <span className="sr-only"></span>
                    </div>}
                  </span>
                  <span className={styles.iconBox}><img src={monthIcon} alt="Month-icon" /></span>
                </div>
              </div>

              <div className={styles.card}>
                <div className={styles.cardTop}>
                  <span className={styles.topContent}>
                    <span>Yesterday</span>

                    {planCount?.yesterdayCount != null ? <span>{planCount.yesterdayCount}</span> : <div className={` spinner-border  ${styles.loaderDiv}`} style={{ color: '#6fa287' }} role="status">
                      <span className="sr-only"></span>
                    </div>}
                  </span>
                  <span className={styles.iconBox}><img src={dayIcon} alt="Day-icon" /></span>
                </div>
              </div>

            </div>
            <div className={styles.panel}>
              <div className={styles.tableHeader}>
                <span className={styles.tableHeaderIcon}><ListIcon /></span>
                <h3>Top Plan Creator</h3>
              </div>
              <div className={styles.chartDiv}>
                <div className={styles.chartContainer}>

                  {topCreators?.length > 0 ? (
                    topCreators.map((item, index) => (
                      <div className={styles.chart}>
                        <LineChart className={styles.lineChart} key={item.rm_code} data={item} index={index} />
                      </div>
                    ))
                  ) : (
                    <p>No data available</p>
                  )}

                  {/* <ul>
            <li>Regional</li>
           </ul> */}
                </div>
              </div>
            </div>
          </div>
          :
          <div className={styles.rightContent}>
            <div className={styles.pageHeader}>
              <span className={styles.pageIcon}><FileIcon /></span>
              <div>
                <h2>Report</h2>
                <p>View and manage all reports with advanced filters and export options.</p>
              </div>
            </div>
            <div className={`${styles.panel} ${styles.downloadDiv}`}>
              <div className={styles.panelTitle}>
                <FilterIcon /><span>Filter By</span>
              </div>


              {/* Filters */}
              <div className={styles.filters}>
                <div className={styles.filterDiv}>
                  <label>From Date</label>
                  <input type="date" name="fromDate" value={filters.fromDate || ""} min="2025-02-10" max={toDate > (new Date().toISOString().split('T')[0]) ? (new Date().toISOString().split('T')[0]) : toDate} onChange={(e) => {
                    setFromDate(e.target.value);
                    handleFilterChange(e);
                  }} />
                </div>
                <div className={styles.filterDiv}>
                  <label>To Date</label>
                  <input type="date" name="toDate" value={filters.toDate || ""} min={fromDate} max={new Date().toISOString().split('T')[0]} onChange={(e) => {
                    setToDate(e.target.value);
                    handleFilterChange(e);
                  }} />
                </div>
                <div className={styles.filterDiv}>
                  <label>Channel</label>
                  <select name="channel" value={filters.channel} onChange={handleFilterChange}>
                    <option value="">All Channels</option>
                    {channelsData.map((channel) => (
                      <option key={channel.CHANNEL} value={channel.CHANNEL}>
                        {channel.CHANNEL}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.filterDiv}>
                  <label>Region</label>
                  <select name="region" value={filters.region} onChange={handleFilterChange}>
                    <option value="">All Regions</option>
                    {regions.map((region) => (
                      <option key={region.REGION_NAME} value={region.REGION_NAME}>
                        {region.REGION_NAME}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.filterDiv}>
                  <label>Zone</label>
                  <select name="zone" value={filters.zone} onChange={handleFilterChange}>
                    <option value="">All Zones</option>
                    {zones.map((zone) => (
                      <option key={zone.ZONE_NAME} value={zone.ZONE_NAME}>
                        {zone.ZONE_NAME}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.filterDiv}>
                  <label>Branch</label>
                  <select name="branch" value={filters.branch} onChange={handleFilterChange}>
                    <option value="">All Branches</option>
                    {branches.map((branch) => (
                      <option key={branch.BRANCH_NAME} value={branch.BRANCH_NAME}>
                        {branch.BRANCH_NAME}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.filterActions}>
                  <button className={styles.searchBtn} onClick={handleSearchSubmit}>
                    <SearchIcon /><span>Search</span>
                  </button>
                  <button className={styles.resetBtn} onClick={() => {
                    setFilters({ channel: "", region: "", zone: "", branch: "" });
                    setFromDate(getLast15DaysStart());
                    setToDate(getNextDate(new Date));
                  }}>
                    <RefreshIcon /><span>Reset</span>
                  </button>
                </div>

              </div>



              <div className={styles.downloadTab}>
                <div className={styles.downloadLabel} title="Download CSV" onClick={localStorage.getItem('isAdmin') == 1 ? downloadAdminCSV : downloadUserCSV}>
                  <DownloadIcon /><span>Download as</span>
                </div>
                <button className={styles.pdfBtn} onClick={localStorage.getItem('isAdmin') == 1 ? downloadAdminPDF : downloadUserPDF}>
                  <FileBadge letter="PDF" color="#e53935" /><span>PDF</span>
                </button>
                <button className={styles.excelBtn} onClick={localStorage.getItem('isAdmin') == 1 ? downloadAdminExcel : downloadUserExcel}>
                  <FileBadge letter="X" color="#1e7e45" /><span>Excel</span>
                </button>
                <button className={styles.wordBtn} onClick={localStorage.getItem('isAdmin') == 1 ? downloadAdminWord : downloadUserWord}>
                  <FileBadge letter="W" color="#2b6cb0" /><span>Word</span>
                </button>
              </div>
            </div>
            <div className={`${styles.panel} ${styles.tablePanel}`}>
              <div className={styles.tableHeader}>
                <span className={styles.tableHeaderIcon}><ListIcon /></span>
                <h3>Report List</h3>
                <span className={styles.recordBadge}>{filteredData.length} Records</span>
              </div>
              <div className={styles.tableDiv}>
                {loading &&
                  <div className={` spinner-border ${styles.loaderDiv}`} style={{ color: '#6fa287' }} role="status">
                    <span className="sr-only"></span>
                  </div>}
                {<table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Channel</th>
                      <th>Region</th>
                      <th>Zone</th>
                      <th>Branch</th>
                      <th>RM Name</th>
                      <th>Business Code</th>
                      <th>Investor</th>
                      <th>RP Plan ID</th>
                      {localStorage.getItem('isAdmin') == 1 && <th>Plan Status</th>}
                      <th>Year of Retirement</th>
                      <th>Plan Creation Date</th>
                      <th>Plan Revision Date</th>
                      <th>Plan Created By</th>
                      <th>Spoc RM Code</th>
                      <th>View Plan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((item, index) => (
                        <tr key={index}>
                          <td className={styles.indexCell}>{index + 1}</td>
                          <td><span className={styles.channelBadge}>{item.CHANNEL}</span></td>
                          <td>{item.REGION_NAME}</td>
                          <td>{item.ZONE_NAME}</td>
                          <td>{item.BRANCH_NAME}</td>
                          <td>{item.spoc_rm_name ? capitalizeName(item.spoc_rm_name) : capitalizeName(item.rmname || item.EMP_NAME)}</td>
                          <td>{item.spoc_rm ? item.spoc_rm : (item.rmcode || item.rm_code)}</td>
                          <td>{capitalizeName(item.client_name)}</td>
                          <td className={styles.planIdCell}>{item.plan_id}</td>
                          {localStorage.getItem('isAdmin') == 1 && (
                            <td>
                              <span className={item.plan_completed == 1 ? styles.statusDone : styles.statusPending}>
                                {item.plan_completed == 1 ? "Plan Created" : "Pending "}
                              </span>
                            </td>
                          )}
                          <td>{getRetirementYear((new Date(item.created_at)).getFullYear(), item.age, item.year_of_retirement)}</td>
                          <td>{formatDate(item.created_at)}</td>
                          <td>{formatDate(item.updated_at)}</td>
                          {/* PLAN cREATED BY */}
                          <td>{capitalizeName(item.rmname || item.EMP_NAME)}</td>
                          <td>{(item.rmcode || item.rm_code)}</td>
                          <td>
                            <button className={styles.viewText} onClick={() => handleVersionSearch(item.plan_id)}>
                              <EyeIcon /><span>View</span>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="16" className={styles.emptyRow}>No data found</td>
                      </tr>
                    )}
                  </tbody>
                </table>}
              </div>
              <div className={styles.tableFooter}>
                Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} entries
              </div>
            </div>
          </div>
        }

      </div>
    </div >
  )
}

const svgProps = { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };
const BarsIcon = () => (<svg {...svgProps} width={26} height={26} strokeWidth={3}><line x1="6" y1="20" x2="6" y2="14" /><line x1="12" y1="20" x2="12" y2="9" /><line x1="18" y1="20" x2="18" y2="4" /></svg>);
const HomeIcon = () => (<svg {...svgProps}><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /><path d="M10 21v-6h4v6" /></svg>);
const FileIcon = () => (<svg {...svgProps}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="14" y2="17" /></svg>);
const FilterIcon = () => (<svg {...svgProps}><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>);
const SearchIcon = () => (<svg {...svgProps}><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>);
const RefreshIcon = () => (<svg {...svgProps}><polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" /></svg>);
const DownloadIcon = () => (<svg {...svgProps}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>);
const ListIcon = () => (<svg {...svgProps} width={22} height={22}><line x1="9" y1="6" x2="21" y2="6" /><line x1="9" y1="12" x2="21" y2="12" /><line x1="9" y1="18" x2="21" y2="18" /><rect x="3" y="4" width="3" height="4" rx="1" /><rect x="3" y="10" width="3" height="4" rx="1" /><rect x="3" y="16" width="3" height="4" rx="1" /></svg>);
const EyeIcon = () => (<svg {...svgProps} width={15} height={15}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>);
const FileBadge = ({ letter, color }) => (
  <svg width="20" height="22" viewBox="0 0 20 22">
    <rect width="20" height="22" rx="3" fill={color} />
    <text x="10" y="15" textAnchor="middle" fontSize={letter.length > 1 ? 6.5 : 11} fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">{letter}</text>
  </svg>
);

export default Admin